export let supportsPassiveEvents = false;
try {
  let opts = Object.defineProperty({}, 'passive', {
    get: function () {
      supportsPassiveEvents = true;
      return true;
    },
  });
  // @ts-ignore
  window.addEventListener('testEvent', null, opts);
  // @ts-ignore
  window.removeEventListener('testEvent', null, opts);
} catch (e) {
}

export function passiveEventOption() {
  return supportsPassiveEvents ? {passive: false} : true;
}
